module.exports = __webpack_public_path__ + "static/media/service-catalog.8b835e81.svg";